export const PRODUCT_DESCRIPTION_PROMPT: any = [
    {
        "role": "system",
        "content": "You are a helpful assistant that creates product descriptions."
    },
    {
        "role": "user",
        "content": "With the {TONE} tone of voice, use the below contents and generate {COUNT} product descriptions that grabs attention of the buyer in 60 seconds. This description is for the product {PRODUCT_NAME} of {PRODUCT_TYPE} product type and designed with a {DESIGN_NAME} pattern in {THEME_NAME} theme.  Start with each description with 'Product Description' heading. Contents: '{CONTENTS}'"
    }
];


export const PRODUCT_DESCRIPTION_META_PROMPT: any = [
    {
        "role": "system",
        "content": "You are a helpful assistant that creates product description, facebook post, meta title and meta description."
    },
    {
        "role": "user",
        "content": "With the {TONE} tone of voice, use the below contents and generate {COUNT} detailed {TONE} product description (with at least 150 words each), SEO compliant {TONE} meta title (strictly with maximum of 50 characters), {TONE} meta description (only with maximum of 160 characters) and {TONE} facebook post details with emojis & hashtags that grabs attention of the buyer in 60 seconds. This description & meta detail are for the product {PRODUCT_NAME} designed with a {DESIGN_NAME} pattern in {THEME_NAME} theme. Return the content as list in JSON format. Group each details with 'productDescription', 'facebookPost', 'metaTitle' & 'metaDescription' attributes in the list\'s objects. Contents: '{CONTENTS}'"
    }
];

export const PRODUCT_META_TITLE_PROMPT: any = [
    {
        "role": "system",
        "content": "You are a helpful assistant that creates multiple meta title."
    },
    {
        "role": "user",
        "content": "Act as a SEO expert for a online e-commerce company, with the {TONE} tone of voice, use the below content and generate {COUNT} unique SEO-compliant {TONE} meta titles (strictly with maximum of 40 characters), that grabs the attention of the buyer in 60 seconds. These meta titles are for the product '{PRODUCT_NAME}' designed with a '{DESIGN_NAME}' pattern in '{THEME_NAME}' theme. Return the content as list in JSON format. \nContent: '{CONTENTS}' {DUPLICATE_META_TITLES}"
    }
];

export const COLLECTION_META_DETAIL_PROMPT: any = [
    {
        "role": "system",
        "content": "You are a helpful assistant that creates page description, meta title and meta description for an URL."
    },
    {
        "role": "user",
        "content": "Checkout the below e-commerce page url and generate SEO-Friendly Page Introduction, Meta Title & Meta Description as unique as possible with engaging tone. \nTitle: '{TITLE}'\n URL: '{URL}'.\n Return the content as list in JSON object format with 'pageIntroduction', 'metaTitle' & 'metaDescription' attributes."
    },
    /*{
        "role": "user",
        "content": "Act as a SEO expert for a online e-commerce company, do not self reference, with the {TONE} tone of voice, checkout the below e-commerce page url and generate a page description (with at least 150 words each), SEO compliant meta title (strictly with maximum of 50 characters), and {TONE} meta description (only with maximum of 160 characters)that grabs attention of the buyer in 60 seconds. Return the content as list in JSON format. Group each details with 'pageDescription', 'metaTitle' & 'metaDescription' attributes in the list\'s objects. Page URL: '{URL}'"
    }*/
];


export const GENERIC_PROMPT: any = [
    {
        "role": "system",
        "content": "You are a helpful assistant that creates {PROMPT_TITLE}."
    },
    {
        "role": "user",
        "content": "{PROMPT_CONTENT}"
    }
];

export const GENERIC_PROMPT_FOLLOWUP: any = [
    {
        "role": "system",
        "content": "You are a helpful assistant that {PROMPT_TITLE}."
    },
    {
        "role": "user",
        "content": "{PROMPT_CONTENT}"
    },
    {
        "role": "assistant",
        "content": "{PREVIOUS_RESPONSE}"
    },
    {
        "role": "user",
        "content": "{NEW_PROMPT_CONTENT}"
    },
];


export const FACEBOOK_AD_TEXT_PROMPT: any = [
    {
        "role": "system",
        "content": "You are a helpful assistant that creates facebook ads details of Text (125 characters), Headline (40 characters) & Link description (25 characters) that grabs attention of the buyer in 30 seconds."
    },
    {
        "role": "user",
        "content": "With the {TONE} tone of voice, Create 1 facebook ads Text (125 characters), and {COUNT} facebook ads list with Headline (40 characters) & Link description (25 characters) and return the generated content as json list data format based on these contents: '{CONTENTS}', Required json response format is: {text:'', ads:{headline:'',link_description:''}]}",
    }
];
